/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  Modal,
  message,
  Tabs,
  Card,
  DatePicker,
} from 'antd';
import {
  CheckCircleOutlined, SearchOutlined, FileSearchOutlined, InfoCircleOutlined,
  DollarOutlined,
} from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import { getAreas, getEstadosGlobales } from 'api/catalogos/index';
import API from 'utils/api';
import {
  getNivelesDeEstudios,
  postNivelDeEstudio,
  deleteNivelDeEstudio,
  patchNivelDeEstudio,
  getNivelDeEstudio,
  autorizarNivelDeEstudio,
} from 'api/catalogos/nivelesDeEstudios';
import { checkToken } from 'api/utils';
import { NOMBRES_PATTERN } from 'utils/patterns';
import {
  ESTATUS_ACTIVO,
  ESTATUS_INACTIVO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import {
  autorizarJornadaModificacion,
  deleteJornadaModificacion,
  getJornadaModificacion,
  getJornadasModificacion,
  patchJornadaModificacion,
  postJornadaModificacion,
} from 'api/catalogos/JornadaModificacion';
import { getEmpleadosFiltered, getEmpleadosvistaOptimized, getTodosLosEmpleados } from 'api/estructuraOrganizacional/empleados';
import { getPlazasvistaOptimized } from 'api/catalogos/plazas';
import { getAdministracionDePlazasvistaOptimized } from 'api/catalogos/admnistracionDePlazas';
import { getUnidadesDeTrabajo } from 'api/estructuraOrganizacional';
import { getPuestos } from 'api/catalogos/puestos';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { get } from 'lodash';
import { getJornadasModificacionDetalle } from 'api/catalogos/JornadaModificacionDetalle';
import { getDatoOperacionalesDeEmpleados } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getTiposDeEmpleados } from 'api/catalogos/tiposDeEmpleados';
import { getJornadasDetalle } from 'api/catalogos/JornadaDetalle';
import { getJornadas } from 'api/catalogos/jornadas';
import moment from 'moment/moment';
import JornadasModificacionDetalle from './JornadaModificacionDetalle';
import TablaDetalleEmpleados from './Consultas/TablaJornadaModificaciones';

export const modificaciondejornadaPermission = {
  permissionModel: 'modificaciondejornada',
  catalogsModels: [],
  tabsModels: [],
};
const { TabPane } = Tabs;

const JornadaModificacion = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableFields, setDisableFields] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [pageActual, setPageActual] = useState(1);
  const [currentParentTabKey, setCurrentParentTabKey] = useState('general');
  const [activeTabSueldo, setActiveTabSueldo] = useState('Detalle');
  const [activeTabPercepciones, setActiveTabPercepciones] = useState('Modificación');
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [empleadosSeleccionados, setEmpleadosSeleccionados] = useState([]);
  const [jornada, setJornada] = useState([]);
  const [jornadadetalle, setJornadadetalle] = useState([]);
  const [jornadaSeleccionada, setJornadaSeleccionada] = useState(null);
  const [isAutorizado, setIsAutorizado] = useState(false);

  const formInstances = [
    form,
  ];

  const baseURI = '/catalogos/modificacion-de-jornada/';

  const fetchData = async () => {
    setLoading(true);
    const _data = await API.get(baseURI, { params: { page: pageActual } });
    const { results } = _data.data;
    setData({ ..._data.data, results });
    setLoading(false);
  };

  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);

      const cleanPage = Number(String(page).replace(/\D/g, '')); // solo dígitos
      const response = await API.get(baseURI, { params: { page: cleanPage, ...q } });

      const { results } = response.data;

      setSelectedRowKeys([]);
      setPageActual(cleanPage);
      setData({ ...response.data, results });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _jornada,
        _jornadadetalle,
        _estados,
        _data,
      ] = await Promise.all([
        getJornadas(),
        getJornadasDetalle(),
        getEstadosGlobales(),
        getJornadasModificacion({ page: pageActual }),
      ]);
      const { results } = _data;
      if (mounted) {
        setJornada(_jornada);
        setJornadadetalle(_jornadadetalle);
        setEstados(_estados);
        setData({ ..._data, results });
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (open) {
      const jornadaInicial = form.getFieldValue('jornada');
      const jornadaDetalleInicial = form.getFieldValue('jornada_detalle');

      if (
        jornadaInicial
        && (jornadaSeleccionada?.jornada !== jornadaInicial
          || jornadaSeleccionada?.jornada_detalle !== jornadaDetalleInicial)
      ) {
        setJornadaSeleccionada({
          jornada: jornadaInicial,
          jornada_detalle: jornadaDetalleInicial,
        });
      }
    }
  }, [open]);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);

    const [key] = selectedRowKeys;
    const match = responseData || data.results.find((item) => item.id === key);
    const _jornada = await getJornadaModificacion(match.id);

    if (_jornada) {
      form.resetFields();

      form.setFieldsValue({
        // eslint-disable-next-line max-len
        fecha_de_autorizacion: _jornada.fecha_de_autorizacion ? moment(_jornada.fecha_de_autorizacion) : null,
        observaciones: _jornada.observaciones || null,
        jornada: typeof _jornada.jornada === 'object' ? _jornada.jornada.id : _jornada.jornada,
        jornada_detalle: typeof _jornada.jornada_detalle === 'object' ? _jornada.jornada_detalle.id : _jornada.jornada_detalle,
        numero_de_oficio: _jornada.numero_de_oficio || null,
        fecha_del_oficio: _jornada.fecha_del_oficio ? moment(_jornada.fecha_del_oficio) : null,
        vigencia_inicial: _jornada.vigencia_inicial ? moment(_jornada.vigencia_inicial) : null,
        vigencia_final: _jornada.vigencia_final ? moment(_jornada.vigencia_final) : null,
        estados_globales: typeof _jornada.estados_globales === 'object'
          ? _jornada.estados_globales.id
          : _jornada.estados_globales,
      });

      setJornadaSeleccionada(
        typeof _jornada.jornada === 'object'
          ? _jornada.jornada.id
          : _jornada.jornada,
      );

      // Normalizar y deshabilitar si está autorizado
      setDisableFields(
        (typeof _jornada.estados_globales === 'object'
          ? _jornada.estados_globales.id
          : _jornada.estados_globales) === ESTATUS_AUTORIZADO,
      );

      setVisible(true);
    }

    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();

      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;

      // Solo formatear fechas si estamos en modo edición
      if (key) {
        if (values.fecha_de_autorizacion) values.fecha_de_autorizacion = moment(values.fecha_de_autorizacion).format('YYYY-MM-DD');

        if (values.fecha_del_oficio) values.fecha_del_oficio = moment(values.fecha_del_oficio).format('YYYY-MM-DD');

        if (values.vigencia_inicial) values.vigencia_inicial = moment(values.vigencia_inicial).format('YYYY-MM-DD');

        if (values.vigencia_final) values.vigencia_final = moment(values.vigencia_final).format('YYYY-MM-DD');
      }

      const saved = key
        ? await patchJornadaModificacion(key, values)
        : await postJornadaModificacion(values);

      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }

      setLoading(false);
    } catch (err) {
      onError(err, setLoading, formInstances);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteJornadaModificacion(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys) => setSelectedRowKeys(keys),
    type: 'checkbox', // permite seleccionar varios empleados
  };

  const onClickAdd = () => {
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onConfirmAutorizar = async () => {
    if (!selectedData?.id) {
      message.warning('No hay una jornada válida seleccionada para autorizar');
      return;
    }

    try {
      setLoading(true);
      await autorizarJornadaModificacion(selectedData.id); //  usa el ID directo
      setConfirmationVisible(false);
      setSelectedRowKeys([]);
      await fetchData(); // actualiza lista
      onSuccess({}, 'Jornada autorizada con éxito');
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      titleText: 'Fecha de Autorización',
      dataIndex: 'fecha_de_autorizacion',
      key: 'fecha_de_autorizacion',
      width: 200,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : 'Sin asignar'),
    },
    {
      titleText: 'Número de Empleados',
      dataIndex: 'numero_de_empleados',
      key: 'numero_de_empleados',
      width: 150,
    },
    {
      titleText: 'Tipo de Empleado',
      key: 'tipos_de_empleado',
      width: 250,
      render: (_, record) => record.tipos_de_empleado?.map((t) => t.descripcion).join(', ') || 'Sin asignar',
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      key: 'tipos_de_nomina_empleado',
      width: 250,
      render: (_, record) => record.tipos_de_nomina_empleado?.map((t) => t.descripcion).join(', ') || 'Sin asignar',
    },
    {
      titleText: 'Puestos',
      key: 'puestos',
      width: 250,
      render: (_, record) => record.puestos?.map((p) => p.descripcion || p.clave_y_descripcion).join(', ') || 'Sin asignar',
    },
    {
      titleText: 'Áreas',
      key: 'directorios_de_area',
      width: 250,
      render: (_, record) => record.directorios_de_area?.map((a) => a.clave_y_nombre || a.nombre).join(', ') || 'Sin asignar',
    },
    {
      titleText: 'Número de Oficio',
      dataIndex: 'numero_de_oficio',
      key: 'numero_de_oficio',
      width: 200,
    },
    {
      titleText: 'Observaciones',
      dataIndex: 'observaciones',
      key: 'observaciones',
      width: 300,
    },
    {
      titleText: 'Estatus',
      key: 'estados_globales',
      width: 150,
      render: (_, record) => record.estados_globales?.descripcion || 'Sin asignar',
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    nombre: [
      requiredRule,
      {
        pattern: NOMBRES_PATTERN,
        message: 'Ingrese un nombre válido',
      },
    ],
  };
  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            cols={columns}
            data={data?.results || []}
            pagination={false}
            paginationCallback={fetchPaginated}
            count={data?.count || 0}
            currentPage={pageActual}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            customActions={[
              {
                onClick: () => {
                  if (!selectedRowKeys.length) {
                    message.warning('Debe seleccionar una jornada para autorizar.');
                    return;
                  }
                  setConfirmationVisible(true);
                },
                permission: { model: 'modificaciondejornada', action: 'autorizar' },
                icon: <CheckCircleOutlined />,
                text: 'Autorizar',
                disabledBySelection: true,
                className: 'success',
              },
            ]}
            disableDelete={selectedData?.estados_globales === ESTATUS_AUTORIZADO}
            permission={permission}
            allowExportPDF={false}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Jornada de Modificación`}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
                onFinishText="Guardar y Continuar"
              />
            )}
            bordered={false}
          >
            <Tabs
              type="card"
              activeKey={currentParentTabKey || 'general'} // Evitar undefined
              onChange={setCurrentParentTabKey}
            >
              <TabPane
                tab={(
                  <span>
                    <InfoCircleOutlined />
                    {' '}
                    Generales
                  </span>
                )}
                key="general"
                forceRender
              >
                <Form
                  layout="vertical"
                  form={form}
                  onFinish={onFinish}
                  scrollToFirstError
                  name="formGenerales"

                >
                  <Row gutter={12}>
                    <Col xs={24} sm={12} md={8}>
                      <Form.Item label="Fecha de Autorización" name="fecha_de_autorizacion">
                        <DatePicker
                          placeholder="Fecha del servidor"
                          format="DD/MM/YYYY"
                          disabled
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={16}>
                      <Form.Item
                        label="Observaciones"
                        name="observaciones"
                      >
                        <Input.TextArea
                          placeholder="Campo alfanumérico de captura libre"
                          maxLength={550}
                          disabled={disableFields}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                      <Form.Item
                        name="jornada"
                        label="Jornada"
                        rules={rules.required}
                        hasFeedback
                      >
                        <Select
                          keyProp="id"
                          labelProp="descripcion"
                          dataSource={jornada}
                          disabled={disableFields}
                          onChange={(value) => {
                            setJornadaSeleccionada(value);
                            form.setFieldsValue({
                              jornada_detalle: null,
                              descripcion_total_horas: null,
                            });
                          }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={16}>
                      <Form.Item
                        name="jornada_detalle"
                        rules={rules.required}
                        label="Días y Horario laboral"
                        hasFeedback
                      >
                        <Select
                          keyProp="id"
                          labelProp="descripcion_rango_horario"
                          dataSource={jornadadetalle
                            // eslint-disable-next-line max-len
                            .filter((item) => item.jornada === jornadaSeleccionada && item.descripcion_rango_horario !== null)
                            .map((item) => ({
                              id: item.id,
                              descripcion_rango_horario: item.descripcion_rango_horario,
                              descripcion_total_horas: item.descripcion_total_horas,
                            }))
                            // eslint-disable-next-line max-len
                            .filter((item, index, self) => index === self.findIndex((t) => t.descripcion_rango_horario === item.descripcion_rango_horario))}
                          onChange={(value) => {
                            const detalleSeleccionado = jornadadetalle.find(
                              (item) => item.id === value && item.jornada === jornadaSeleccionada,
                            );
                            form.setFieldValue('descripcion_total_horas', detalleSeleccionado?.descripcion_total_horas || null);
                          }}
                          disabled={disableFields}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                      <Form.Item
                        label="No. de Oficio"
                        name="numero_de_oficio"
                        rules={[{ required: true, message: 'Campo requerido' }]}
                      >
                        <Input
                          placeholder="Ej. RH-2025-1464"
                          disabled={disableFields}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                      <Form.Item
                        label="Fecha del Oficio"
                        name="fecha_del_oficio"
                        rules={[{ required: true, message: 'Campo requerido' }]}
                      >
                        <DatePicker
                          format="DD/MM/YYYY"
                          disabled={disableFields}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                      <Form.Item
                        label="Vigencia Inicial"
                        name="vigencia_inicial"
                        rules={[{ required: true, message: 'Campo requerido' }]}
                      >
                        <DatePicker
                          format="DD/MM/YYYY"
                          disabled={disableFields}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                      <Form.Item
                        label="Vigencia Final"
                        name="vigencia_final"
                      >
                        <DatePicker
                          format="DD/MM/YYYY"
                          disabled={disableFields}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                      <Form.Item
                        label="Estatus"
                        name="estados_globales"
                        initialValue={1}
                        rules={[{ required: true, message: 'Campo requerido' }]}
                      >
                        <Select
                          disabled
                          dataSource={estados}
                          keyProp="id"
                          labelProp="descripcion"
                          placeholder="Activo"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item hidden>
                    <Button htmlType="submit" />
                  </Form.Item>
                </Form>
              </TabPane>
              <TabPane
                tab="Detalle"
                key="Detalle"
                forceRender
                disabled={disableFields}
              >

                <TablaDetalleEmpleados
                  JornadaModificacion={selectedRowKeys[0]}
                  onSeleccionChange={setEmpleadosSeleccionados}
                />

              </TabPane>

              <TabPane
                tab="Modificación"
                key="Modificación"
                forceRender
              >
                <JornadasModificacionDetalle
                  JornadaModificacion={selectedRowKeys[0]}
                  disableDelete={disableFields}
                />
              </TabPane>

            </Tabs>

          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`¿Desea autorizar la jornada con oficio ${form.getFieldValue('numero_de_oficio')}?`}
          loading={loading}
        />

        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => {
            setConfirmationVisible(false);
          }}
          open={confirmationVisible}
          contentTitle={`Autorizar jornada ${form.getFieldValue('numero_de_oficio')}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default JornadaModificacion;
